export const ACH_ALLOWLIST = ['1800948598', '4270465600', '0000004670'] as const
export type ACHNumber = (typeof ACH_ALLOWLIST)[number]
